import { gridSize } from '@/shared';
import { Grid } from '@mui/material';
import { useEquiposAdicionalesTable } from '../ProspectoAndPreventa/hooks';
import SampleTable from '../SampleTable';
import { IEquipoServicioAdicionales } from '@/shared/interfaces';

interface TablaEquipoAdicionalComponenteProps {
  equipos_adicionales?: IEquipoServicioAdicionales[];
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
}
export default function TablaEquipoAdicionalComponente({
  equipos_adicionales,
  size = gridSize }: Readonly<TablaEquipoAdicionalComponenteProps>) {
  //HOOKS
  const { columnsEquiposAdicionalesAgenda } = useEquiposAdicionalesTable({
    showItemPrice: false,
  });

  return (
    <Grid item {...size}>
      <SampleTable
        columns={columnsEquiposAdicionalesAgenda}
        data={equipos_adicionales || []}
      />
    </Grid>
  );
}
